module.exports = __webpack_public_path__ + "static/media/TuesdaySpecial2x.624417b9.png";